import { FC } from 'react';
import { WideLink } from 'components/Typography';
import { Card, Flex, Text, Image, CardProps, TextProps, LinkProps } from 'roo-ui/components';
import { rem } from 'polished';

interface InfoAlertProps extends CardProps {
  iconSrc: string;
  iconWidth?: string | number;
}

const DEFAULT_ICON_WIDTH = rem(32);

const InfoAlertBase: FC<InfoAlertProps> = ({ children, iconSrc, iconWidth = DEFAULT_ICON_WIDTH, ...rest }) => (
  <Card data-testid="scheduled-payment" p={6} {...rest}>
    <Flex flexDirection="row" alignItems="flex-start">
      <Image inline src={iconSrc} width={iconWidth} mt={1} />
      <Flex flexDirection="column" alignItems="left" ml={5}>
        {children}
      </Flex>
    </Flex>
  </Card>
);

const Heading: FC<TextProps> = (props) => <Text as="div" fontSize="lg" fontWeight="bold" {...props} />;
const Body: FC<TextProps> = (props) => <Text as="div" fontSize="sm" color="emperor" {...props} />;
const Link: FC<LinkProps> = (props) => <WideLink variant="primary" mt={2} {...props} />;

export const InfoAlert = Object.assign(InfoAlertBase, { Heading, Body, Link });
